export const SENSOR_CONFIGURATION_THRESHOLD = "2.7.0";